import { render } from "./skeleton.vue?vue&type=template&id=7e197191&scoped=true"
import script from "./skeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./skeleton.vue?vue&type=script&setup=true&lang=js"

import "./skeleton.vue?vue&type=style&index=0&id=7e197191&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e197191"],['__file',"resources/js/v2/components/skeleton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7e197191"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7e197191', __exports__)) {
    console.log('reload')
    api.reload('7e197191', __exports__)
  }
  
  module.hot.accept("./skeleton.vue?vue&type=template&id=7e197191&scoped=true", () => {
    console.log('re-render')
    api.rerender('7e197191', render)
  })

}


export default __exports__